<template>
  <component :is="active" :data="data" @changeStatus="changeStatus"></component>
</template>

<script>
export default {
  name: 'reset',
  mixins: [],
  data() {
    return {
      active: 'ForgetPwd',
      data: {}
    }
  },
  components: {
    //输入账户页
    ForgetPwd: () => import('@/views/password/ForgetPwd.vue'),
    //有两种验证方式页
    VerifyBoth: () => import('@/views/password/VerifyBoth.vue'),
    //没有验证方式页
    VerifyNone: () => import('@/views/password/VerifyNone.vue'),
    //邮箱验证页
    VerifyEmail: () => import('@/views/password/VerifyEmail.vue'),
    //手机验证页
    VerifyPhone: () => import('@/views/password/VerifyPhone.vue'),
    //链接失效页
    LinkError: () => import('@/views/password/LinkError.vue'),
    //设置密码页
    SetPassword: () => import('@/views/password/SetPassword.vue'),
    //设置密码成功页
    Success: () => import('@/views/password/Success.vue')
  },
  created() {
    this.checkUrl()
  },
  mounted() {
    //此方法刷新页面时也会执行
    window.addEventListener('beforeunload', () => {
      sessionStorage.removeItem('sendData')
    })
  },
  methods: {
    changeStatus(status, data) {
      this.active = status
      this.data = data
    },
    checkUrl() {
      //判断url中是否有token和uid   如果有的话 跳转到设置密码页 设置密码页校验
      if (this.$route.query.token && this.$route.query.uid) {
        //eslint-disable-next-line
        if ($('#timeOut').val() === 'false') {
          this.active = 'SetPassword'
        } else {
          this.active = 'LinkError'
        }
      }
    }
  }
}
</script>
